import type { Resource } from '../../';
export const country_countries_FI: Resource = {"default":"Finland"};
